import styled from "styled-components"

export type ElementSize = "xs" | "sm" | "md" | "lg" | "xl"

const getColumnNumber = (size: ElementSize) => {
    if (size === "xs") return 4
    if (size === "sm") return 5
    if (size === "md") return 6
    if (size === "lg") return 7
    if (size === "xl") return 8
    return 6
}

export const DriveContentWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: 100%;
`
export const MenuButton = styled.div<{
    blockView?: boolean
}>`
    ${(props) => props.blockView && `
        position: absolute;
        height: 20px;
        width: 16px;
        padding: 0 2px;
        top: 7px;
        left: 10px;
        z-index: 1;
    `}

    cursor: pointer;
    color: ${(props) => props.theme.driveElementMenuButtonColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.driveElementMenuButtonColorHover};
    }
`
export const CheckButton = styled.div<{
    blockView?: boolean
    listView?: boolean
    checked: boolean
}>`
    ${(props) => props.blockView && `
        position: absolute;
        top: 10px;
        right: 12px;
        opacity: ${props.checked ? 1 : 0};
        z-index: 1;
    `}

    ${(props) => props.listView && `
        position: relative;
    `}

    width: 18px;
    height: 18px;
    cursor: pointer;
    border-radius: 2px;
    border: 1px solid ${(props) => props.theme.driveElementCheckboxBorderColor};
    background: ${(props) => props.theme.driveElementCheckboxBackgroundColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:after {
        display: ${(props) => (props.checked ? "block" : "none")};
        content: "\f00c";
        font-family: "FontAwesome";
        position: absolute;
        top: -1px;
        font-size: 16px;
        line-height: 18px;
        color: ${(props) => props.theme.driveElementCheckboxColor};
    }
`
export const ContextMenuTarget = styled.div`
    position: absolute;
    height: 2px;
    width: 6px;
    top: 0;
    left: 0;
    transform: translateX(-50%);
`


// blocks style

export const ElementWrapper = styled.div<{
    size: ElementSize
    selected: boolean
}>`
    width: calc((100% - 8px * 2 * ${(props) => getColumnNumber(props.size)}) / ${(props) => getColumnNumber(props.size)});
    float: left;
    margin: 8px;
    position: relative;
    border: 1px solid ${(props) => props.theme.driveElementBorderColor};
    background: ${(props) => (props.selected
        ? props.theme.driveElementBackgroundColorSelected
        : props.theme.driveElementBackgroundColor
    )};

    &::before {
        content: '';
        display: block;
        padding-top: 100%;
    }

    &:hover {
        background: ${(props) => (props.selected
        ? props.theme.driveElementBackgroundColorSelectedHover
        : props.theme.driveElementBackgroundColorHover
    )};
    }

    &:hover > ${CheckButton} {
        opacity: 1;
    }
`
export const ElementLogo = styled.img`
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    padding: 30px 22px 35px;
    object-fit: contain;
    object-position: center;
    vertical-align: middle;
`
export const ElementName = styled.span<{
    offsetRight: boolean
}>`
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: ${(props) => (props.offsetRight ? "8px 36px 8px 16px" : "8px 16px")};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
`
export const ElementIconWrapper = styled.div`
    position: absolute;
    right: 6px;
    bottom: 6px;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
`


// list style

const checkboxWidth = "42px"
const logoWidth = "68px"
const ownerWidth = "15%"
const modifiedWidth = "15%"
const sizeWidth = "10%"
const menuWidth = "34px"


export const ListHeaderWrapper = styled.div`
    display: flex;
    width: calc(100% - 15px * 2);
    margin: 0 15px;
`
const ListHeader = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 8px 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: ${(props) => props.theme.openSans};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${(props) => props.theme.tableColor};
`
export const ListHeaderCheckbox = styled(ListHeader)`
    width: ${checkboxWidth};
`
export const ListHeaderLogo = styled(ListHeader)`
    width: ${logoWidth};
`
export const ListHeaderTitle = styled(ListHeader)`
    width: calc(100% - ${checkboxWidth} - ${logoWidth} - ${ownerWidth} - ${modifiedWidth} - ${sizeWidth} - ${menuWidth});
`
export const ListHeaderOwner = styled(ListHeader)`
    width: ${ownerWidth};
`
export const ListHeaderModified = styled(ListHeader)`
    width: ${modifiedWidth};
`
export const ListHeaderSize = styled(ListHeader)`
    width: ${sizeWidth};
`
export const ListHeaderMenu = styled(ListHeader)`
    width: ${menuWidth};
`


export const ListRowWrapper = styled.div<{
    selected: boolean
}>`
    position: relative;
    display: flex;
    width: calc(100% - 15px * 2);
    margin: 0 15px;
    border-top: 1px solid ${(props) => props.theme.driveListElementBorderColor};
    background: ${(props) => (props.selected
        ? props.theme.driveElementBackgroundColorSelected
        : "transparent"
    )};

    &:hover {
        background: ${(props) => (props.selected
        ? props.theme.driveElementBackgroundColorSelectedHover
        : props.theme.driveElementBackgroundColor
    )};
    }
`
const ListRow = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`
export const ListRowCheckbox = styled(ListRow)`
    width: ${checkboxWidth};
    justify-content: center;
`
export const ListRowLogo = styled(ListRow)`
    position: relative;
    height: ${logoWidth};
    width: ${logoWidth};
`
export const ListRowLogoImage = styled.img`
    height: calc(${logoWidth} - 12px * 2); // 12 - padding
    width: calc(${logoWidth} - 12px * 2);
    object-fit: contain;
    object-position: center;
    vertical-align: middle;
`
export const ListRowTitle = styled(ListRow)`
    position: relative;
    width: calc(100% - ${checkboxWidth} - ${logoWidth} - ${ownerWidth} - ${modifiedWidth} - ${sizeWidth} - ${menuWidth});

    & > a {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`
export const ListRowOwner = styled(ListRow)`
    width: ${ownerWidth};
`
export const ListRowModified = styled(ListRow)`
    width: ${modifiedWidth};
`
export const ListRowSize = styled(ListRow)`
    width: ${sizeWidth};
`
export const ListRowMenu = styled(ListRow)`
    width: ${menuWidth};
    justify-content: center;
    cursor: pointer;

    &:hover > ${MenuButton} {
        color: ${(props) => props.theme.driveElementMenuButtonColorHover};
    }
`


export const ListFolderIconWrapper = styled.div`
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid white;
    border-radius: 50%;
`
export const ListFileIconWrapper = styled.div`
    position: absolute;
    right: 5px;
    bottom: 5px;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${(props) => props.theme.driveListElementFileIconBackground};
`


// empty list

export const EmptyListWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > i {
        font-size: 70px;
        color: ${(props) => props.theme.driveEmptyButtonColor};
    }
`
export const EmptyListTitle = styled.div`
    font-size: 30px;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 300;
    margin-bottom: 20px;
`
export const EmptyListButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
`
export const EmptyListButton = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 115px;
    padding: 0 80px;
    margin: 0 10px;
    background: transparent;
    border: 2px dashed ${(props) => props.theme.driveEmptyButtonColor};
    border-radius: 3px;
    white-space: nowrap;
    font-family: ${((props) => props.theme.openSans)};
    font-size: ${(props) => props.theme.fontSizes.lg}px;
    color: ${(props) => props.theme.driveEmptyButtonColor};
    cursor: pointer;
    transition: 0.1s;

    &:hover {
        border-color: ${(props) => props.theme.driveEmptyButtonHoverColor};
        background: ${(props) => props.theme.driveEmptyButtonHoverBackground};
        color: ${(props) => props.theme.driveEmptyButtonHoverColor};
    }

    & > i {
        font-size: 40px;
        margin-right: 15px;
    }

    & > input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
`
